import { render, staticRenderFns } from "./spam-sms-order.vue?vue&type=template&id=0e04de31&"
import script from "./spam-sms-order.vue?vue&type=script&lang=js&"
export * from "./spam-sms-order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports